<template>
  <v-dialog
    fullscreen
    eager
    v-model="dialog"
    hide-overlay
    content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>
      <v-stepper v-model="stepper">
        <v-stepper-header>
          <v-stepper-step
              :complete="stepper > 1"
              step="1"
          >
            {{ $t('book/issue:drop-down-dialog.select-document-type') }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
              :complete="stepper > 2"
              step="2"
          >
            {{ createStepLabel }}
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <div class="text-center">
              <v-btn
                  color="primary"
                  :disabled="disableNextStep"
                  @click="nextStep"
              >
                 {{ $t('buttons:next-step') }}
              </v-btn>
            </div>
            <FirstStep
                ref="firstStep"
                :uploadedFile="file"
                @documentTypeChanged="checkButtonEnable"
                @facilityIdChanged="checkButtonEnable"
                @taskChanged="checkButtonEnable"
                @customerIdChanged="(v) => { customerId = v }"
            />
          </v-stepper-content>
          <v-stepper-content step="2">
            <div class="text-center">
              <v-btn
                color="primary"
                @click="save"
              >
                {{ createStepLabel }}
              </v-btn>
              <v-btn
                  @click="stepper = 1"
                  text>
                {{ $t('buttons:back') }}
              </v-btn>
            </div>
            <CreateGlobalContractStep
                ref="globalContract"
                @dialogClosed="() => closeDialog()"
                v-if="documentType === 'globalContract'" />
            <CreateGlobalDocumentationStep
                ref="globalDocument"
                @dialogClosed="() => closeDialog()"
                v-if="documentType === 'globalDocument'" />
            <CreateLocalContractStep
                ref="localContract"
                @dialogClosed="() => closeDialog()"
                v-if="documentType === 'localContract'"/>
            <CreateLocalDocumentationStep
                ref="localDocumentation"
                @dialogClosed="() => closeDialog()"
                v-if="documentType === 'localDocumentation'" />
            <CreateOfferStep
              ref="offerDocumentation"
              @dialogClosed="() => closeDialog()"
              v-if="documentType === 'offerDocumentation'" />
            <CreateInvoiceStep
              ref="invoiceDocumentation"
              @dialogClosed="() => closeDialog()"
              v-if="documentType === 'invoiceDocumentation'" />
            <CreateTaskStep
                ref="taskDocumentation"
                @dialogClosed="() => closeDialog()"
                v-if="documentType === 'taskDocumentation'" />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>
<script>

import FirstStep from '@/modules/book/views/task/dashboard-table/steps/FirstStep.vue';
import CreateGlobalContractStep from '@/modules/book/views/task/dashboard-table/steps/CreateGlobalContractStep.vue';
import CreateGlobalDocumentationStep
  from '@/modules/book/views/task/dashboard-table/steps/CreateGlobalDocumentationStep.vue';
import CreateLocalContractStep from '@/modules/book/views/task/dashboard-table/steps/CreateLocalContractStep.vue';
import CreateLocalDocumentationStep
  from '@/modules/book/views/task/dashboard-table/steps/CreateLocalDocumentationStep.vue';
import CreateOfferStep from "@/modules/book/views/task/dashboard-table/steps/CreateOfferStep.vue";
import CreateInvoiceStep from "@/modules/book/views/task/dashboard-table/steps/CreateInvoiceStep.vue";
import CreateTaskStep from "@/modules/book/views/task/dashboard-table/steps/CreateTaskStep.vue";
import DocumentType from "@/modules/book/views/task/dashboard-table/steps/DocumentType";

export default {
  name: 'DragAndDropDialog',
  components: {
    CreateTaskStep,
    CreateInvoiceStep,
    CreateOfferStep,
    FirstStep,
    CreateGlobalContractStep,
    CreateGlobalDocumentationStep,
    CreateLocalContractStep,
    CreateLocalDocumentationStep
  },
  data() {
    return {
      dialog: false,
      file: {},
      stepper: 1,
      disableNextStep: true,
      documentType: '',
      facilityId: '',
      task: '',
      customerId: ''
    }
  },
  computed: {
    documentTypes() {
      return DocumentType.getDocumentTypes();
    },
    createStepLabel() {
      if (!this.documentType) return this.$t('buttons:create-specific', { specific: this.$t('common:documentation')});

      let documentTypes = this.documentTypes;
      for(let i = 0; i < documentTypes.length; i++) {
        if (documentTypes[i].id === this.documentType) {
          return this.$t('buttons:create-specific', { specific: this.$t('book/issue:' + documentTypes[i].name)});
        }
      }

      return '';
    }
  },
  methods: {
    openDialog(file) {
      this.file = file;
      this.dialog = true;
      this.$refs.firstStep.setFile(this.file);
    },
    checkButtonEnable() {
      this.disableNextStep = true;
      let dataFromFirstStep = this.$refs.firstStep.getData();
      this.documentType = '';
      this.facilityId = '';

      if (!dataFromFirstStep.type) return;

      this.documentType = dataFromFirstStep.type;
      let isGlobal = dataFromFirstStep.type === 'globalContract' || dataFromFirstStep.type === 'globalDocument';
      if (dataFromFirstStep.type && isGlobal) {
        this.disableNextStep = false;
        return;
      }

      let isLocalContract = dataFromFirstStep.type === 'localContract'
          || dataFromFirstStep.type === 'localDocumentation';
      if (isLocalContract && dataFromFirstStep.facilityId && dataFromFirstStep.facilityId.length > 0) {
        this.disableNextStep = false;
        this.facilityId = dataFromFirstStep.facilityId;
      }

      let isTask = dataFromFirstStep.type === 'invoiceDocumentation'
          || dataFromFirstStep.type === 'offerDocumentation'
          || dataFromFirstStep.type === 'taskDocumentation';
      if (isTask && dataFromFirstStep.task && dataFromFirstStep.task.id && dataFromFirstStep.task.id.length > 0) {
        this.disableNextStep = false;
        this.taskId = dataFromFirstStep.task;
      }

    },
    save() {
      if (!this.documentType || this.documentType.length === 0) {
        return;
      }

      this.$refs[this.documentType].save();
    },
    nextStep() {
      if (!this.documentType || this.documentType.length === 0) {
        return;
      }
      this.$refs[this.documentType].setInputData(
          {
            documentType: this.documentType,
            facilityId: this.facilityId,
            taskId: this.taskId ? this.taskId.id : null,
            signedOffer: this.taskId ? this.taskId.signedOffer : null,
            file: this.file,
            customerId: this.customerId
          }
      );
      this.stepper = 2;
    },
    closeDialog() {
      this.dialog = false;
      this.$emit('onClose');
      if (this.$refs[this.documentType]) {
        this.$refs[this.documentType].cancelDialog();
      }
      this.$refs.firstStep.clearData();
      this.file = {};
      this.stepper = 1;
      this.disableNextStep = true;
      this.documentType = '';
      this.facilityId = '';
      this.taskId = '';
    },
    updateData() {
      this.$refs.firstStep.updateData();
    }
  }
}
</script>